export default class Passo4 {
  constructor(id, listaLinha = [], listaResumo = []) {
    this.id = id;
    this.listaLinha = listaLinha;
    this.listaResumo = listaResumo;
  }
}
